import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { Icon } from "@ddm-design-system/icon";
import { TertiaryButton } from "@ddm-design-system/button";
import StyleConstants from "../../../constants";
import useIsMobile from "../../../hooks/useIsMobile";
import Routes from "../../../routes";
import useContent from "../../../hooks/useContent";
import { getFeedbackFormUrl } from "../../../helpers";
import "./footer.scss";

export interface IProps {
  locale: string;
}

export const Footer: React.FC<RouteComponentProps & IProps> = ({ history, locale }) => {
  const isMobile = useIsMobile(StyleConstants.mobileBreakpoint1);
  const lang = locale.split("-")[0];
  const { managerAppCommon: content } = useContent();

  if (
    history.location.pathname === Routes.login ||
    history.location.pathname === Routes.firstLogin
  ) {
    return <></>;
  }

  const Feedback = () => (
    <a
      className="footer-feedback-anchor"
      href={getFeedbackFormUrl(lang)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <TertiaryButton icon="feedback" className="footer-feedback-text">
        {content.manager_app_footer_feedback_link}
      </TertiaryButton>
    </a>
  );

  return !isMobile ? (
    <div className="footer">
      <div className="footer-content">
        <Icon name="dm-full-logo" height={32} />
        <Feedback />
      </div>
    </div>
  ) : (
    <div className="footer">
      <Feedback />
    </div>
  );
};

export default withRouter(Footer);
